import { Routes } from '~constants/routes'
import { generateQuery, GenerateQueryProps } from '~utils/generateQuery'

interface UrlParams extends GenerateQueryProps {
    route: Routes
    currencyRoute?: string
}

export const generateUrl = (params: UrlParams) => {
    const { route, currencyRoute, ...query } = params

    let url = `/${route}`

    const queryUrl = generateQuery({
        ...query,
    })

    if (currencyRoute) {
        url = `${url}/${currencyRoute}`
    }

    return `${url}${queryUrl}`
}
